import { render, staticRenderFns } from "./ui.vue?vue&type=template&id=01b669e1&scoped=true"
import script from "./ui.vue?vue&type=script&lang=js"
export * from "./ui.vue?vue&type=script&lang=js"
import style0 from "./ui.vue?vue&type=style&index=0&id=01b669e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b669e1",
  null
  
)

export default component.exports